import moment from "moment";
import "moment/locale/zh-cn";
import { createApp } from "vue";
import { Toast } from "vant";
import { Dialog } from "vant";
import axios from "./axios";
import res from "./res";
import ImageCompressor from "js-image-compressor";

moment.locale("zh-cn", {
  months:
    "一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月".split(
      "_"
    ),
  monthsShort: "1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月".split("_"),
  weekdays: "星期日_星期一_星期二_星期三_星期四_星期五_星期六".split("_"),
  weekdaysShort: "周日_周一_周二_周三_周四_周五_周六".split("_"),
  weekdaysMin: "日_一_二_三_四_五_六".split("_"),
  longDateFormat: {
    LT: "HH:mm",
    LTS: "HH:mm:ss",
    L: "YYYY-MM-DD",
    LL: "YYYY年MM月DD日",
    LLL: "YYYY年MM月DD日Ah点mm分",
    LLLL: "YYYY年MM月DD日ddddAh点mm分",
    l: "YYYY-M-D",
    ll: "YYYY年M月D日",
    lll: "YYYY年M月D日 HH:mm",
    llll: "YYYY年M月D日dddd HH:mm",
  },
  meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
  meridiemHour: function (hour, meridiem) {
    if (hour === 12) {
      hour = 0;
    }
    if (meridiem === "凌晨" || meridiem === "早上" || meridiem === "上午") {
      return hour;
    } else if (meridiem === "下午" || meridiem === "晚上") {
      return hour + 12;
    } else {
      // '中午'
      return hour >= 11 ? hour : hour + 12;
    }
  },
  meridiem: function (hour, minute, isLower) {
    const hm = hour * 100 + minute;
    if (hm < 600) {
      return "凌晨";
    } else if (hm < 900) {
      return "早上";
    } else if (hm < 1130) {
      return "上午";
    } else if (hm < 1230) {
      return "中午";
    } else if (hm < 1800) {
      return "下午";
    } else {
      return "晚上";
    }
  },
  calendar: {
    sameDay: "[今天]LT",
    nextDay: "[明天]LT",
    nextWeek: "[下]ddddLT",
    lastDay: "[昨天]LT",
    lastWeek: "[上]ddddLT",
    sameElse: "L",
  },
  dayOfMonthOrdinalParse: /\d{1,2}(日|月|周)/,
  ordinal: function (number, period) {
    switch (period) {
      case "d":
      case "D":
      case "DDD":
        return number + "日";
      case "M":
        return number + "月";
      case "w":
      case "W":
        return number + "周";
      default:
        return number;
    }
  },
  relativeTime: {
    future: "%s内",
    past: "%s前",
    s: "几秒",
    ss: "%d秒",
    m: "1分钟",
    mm: "%d分钟",
    h: "1小时",
    hh: "%d小时",
    d: "1天",
    dd: "%d天",
    M: "1个月",
    MM: "%d个月",
    y: "1年",
    yy: "%d年",
  },
  week: {
    // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
    dow: 1, // Monday is the first day of the week.
    doy: 4, // The week that contains Jan 4th is the first week of the year.
  },
});
let util = {
  formatValue(item, mapping, index) {
    if (mapping.config.formatValue) {
      const C = {
        template: "<div>" + mapping.config.formatValue + "</div>",
        data() {
          return {
            item: item,
            mapping: mapping,
            index: index,
          };
        },
      };
      var div = document.createElement("div");
      let component = createApp(C).mount(div);
      return component.$el.outerHTML;
    } else {
      return item[mapping.field];
    }
  },
  isFunction(fun) {
    return typeof fun === "function";
  },
  isObject(obj) {
    return typeof obj === "object";
  },
  // getLogo(){
  //   return logo;
  // },
  moment(data) {
    return moment(data);
  },
  windowFrame: function () {
    //获取窗体宽高
    return {
      w: document.documentElement.clientWidth,
      h: document.documentElement.clientHeight,
    };
  },
  confirm(content, confirm, cancel) {
    Dialog.confirm({
      title: "提示",
      message: content,
      confirmButtonColor: "#1aad19",
    })
      .then(() => {
        // on confirm
        if (confirm) {
          confirm();
        }
      })
      .catch(() => {
        // on cancel
        if (cancel) {
          cancel();
        }
      });
  },
  confirm2(title,content, confirm, cancel) {
    Dialog.confirm({
      title: title,
      message: content,
      confirmButtonColor: "#1aad19",
    })
        .then(() => {
          // on confirm
          if (confirm) {
            confirm();
          }
        })
        .catch(() => {
          // on cancel
          if (cancel) {
            cancel();
          }
        });
  },
  prompt({
    title,
    content,
    success,
    cancel,
    value,
    inputPattern,
    inputType,
  }) {},
  yuan(val) {
    return `¥ ${numeral(val).format("0,0")}`;
  },
  showLoading(content) {
    Toast.loading({
      message: content ? content : "加载中",
      lockScroll: true,
      forbidClick: true,
      duration: 0,
    });
  },
  hideLoading() {
    Toast.clear();
  },
  toast(content) {
    Toast(content);
  },
  error(content) {
    Toast.fail(content);
  },
  success(content) {
    Toast.success(content);
  },
  isWechat() {
    let ua = window.navigator.userAgent.toLowerCase();
    if (ua.match(/MicroMessenger/i) == "micromessenger") return true;
    return false;
  },

  getLocation() {
    return new Promise((resolve, reject) => {
      // this.showLoading();
      let options = {
        enableHighAccuracy: true, //是否获取更精确的位置
        timeout: 5000, //请求超时时间,单位ms；
        // 最长有效期，在重复获取地理位置时，此参数指定多久再次获取位置。
        maximumAge: 5000,
      };
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          async (position) => {
            try {
              let res = await axios.execute("Followup", "getConvertAddress", {
                lat: position.coords.latitude + "",
                lng: position.coords.longitude + "",
              });
              let result = {
                lat: res.lat + "",
                lng: res.lng + "",
                address: res.address,
              };
              resolve(result);
            } catch (e) {
              console.log(e);
              let error = "获取定位失败:" + e;
              reject(error);
            }

          },
          (e) => {
            let errorMsg = "";
            switch(e.code) {
              case e.PERMISSION_DENIED:
                errorMsg = "用户拒绝了定位请求，请在浏览器设置中允许定位权限";
                break;
              case e.POSITION_UNAVAILABLE:
                errorMsg = "位置信息不可用，请检查网络连接";
                break;
              case e.TIMEOUT:
                errorMsg = "定位请求超时，请稍后重试";
                break;
              default:
                errorMsg = "获取定位失败: " + e.message;
            }
            console.warn("浏览器定位失败:", errorMsg);
            axios.execute("Followup", "getIpAddressByGaode").then(res=>{
              console.log("res",res)
              if(!res.rectangle){
                let error = "获取定位失败:" + e;
                reject(error);
                return;
              }
              let rectangle =res.rectangle;
              let result = {
                lat: rectangle[0] + "",
                lng: rectangle[1] + "",
                address: res.province + res.city,
              };
              resolve(result);
            }).catch(e=>{
              console.log("高德api获取定位失败",e);
              let error = "获取定位失败:" + e;
              reject(error);
            });
            //用腾旭api超时会直接失败
            // var geolocation = new qq.maps.Geolocation(
            //   "TLSBZ-EXKOS-GPIOI-6RJDQ-5WM6E-Y4BVP",
            //   "myapp"
            // );
            // geolocation.getLocation(
            //   (res) => {
            //     let result = {
            //       lat: res.lat + "",
            //       lng: res.lng + "",
            //       address: res.province + res.city + res.addr,
            //     };
            //     resolve(result);
            //     // this.hideLoading();
            //   },
            //   (e) => {
            //     // let error = "获取定位失败:" + e;
            //     // this.$util.hideLoading();
            //     // reject(error);
            //     // console.log("腾讯api获取定位失败",e);
            //     // var xhttp = new XMLHttpRequest();
            //     // xhttp.onreadystatechange = function() {
            //     //   if (this.readyState == 4 && this.status == 200) {
            //     //     var response = JSON.parse(xhttp.responseText);
            //     //     axios.execute("Followup", "getIpAddress", {ip:response.ip})
            //     //       .then(function(response) {
            //     //         let ipResult=response.result;
            //     //         let result = {
            //     //           lat: ipResult.location.lat + "",
            //     //           lng: ipResult.location.lng + "",
            //     //           address: ipResult.ad_info.province + ipResult.ad_info.city,
            //     //         };
            //     //         resolve(result);
            //     //       });
            //     //   }
            //     // };
            //     // xhttp.open("GET", "https://api.ipify.org/?format=json", true);
            //     // xhttp.send();
            //     // axios.execute("Followup", "getIpAddress", {ip:response.ip})
            //     //       .then(function(response) {
            //     //         let ipResult=response.result;
            //     //         let result = {
            //     //           lat: ipResult.location.lat + "",
            //     //           lng: ipResult.location.lng + "",
            //     //           address: ipResult.ad_info.province + ipResult.ad_info.city,
            //     //         };
            //     //         resolve(result);
            //     //       });
            //   },
            //   options
            // );
          },
          options
        );
      } else {
        error = "获取定位失败";
        // this.hideLoading();
      }
    });
  },
  //压缩图片
  compressionImage(file) {
    return new Promise((resolve, reject) => {
      // eslint-disable-next-line no-new
      new ImageCompressor({
        file: file,
        quality: 0.8,
        maxWidth: 720,
        maxHeight: 720,
        redressOrientation: false,

        // 压缩前回调
        beforeCompress: function (result) {
          console.log("压缩之前图片尺寸大小: ", result.size);
          console.log("mime 类型: ", result.type);
        },

        success: function (result) {
          console.log("压缩之后图片尺寸大小: ", result.size);
          console.log("mime 类型: ", result.type);
          console.log(
            "实际压缩率： ",
            (((file.size - result.size) / file.size) * 100).toFixed(2) + "%"
          );
          resolve(result);
        },
        error(e) {
          reject(e);
        },
      });
    });
  },
  dataURLtoFile(dataurl, filename) {
    const arr = dataurl.split(",");
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, {
      type: mime,
    });
  },
  isImage(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = (event) => {
        const img = new Image();
        img.src = event.target.result;
        img.onload = () => resolve(true);
        img.onerror = () => resolve(false);
      };
      reader.onerror = (error) => reject(error);
    });
  },
  convertDistance(distance) {
    if (distance < 1000) {
      return distance + " 米";
    } else {
      return distance / 1000 + " 千米";
    }
  },
};
if (process.env.NODE_ENV === "production") {
  console.log = function () {};
}
export default util;
